"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import Image from "next/image";

import "swiper/css";
import "swiper/css/pagination";

const clientList = [
  "/images/clients/client-1.png",
  "/images/clients/client-3.jpg",
  "/images/clients/client-4.jpeg",
];
const isFewSlides = clientList.length <= 3;

const ClientBanner = () => {
  return (
    <>
      <section className="relative overflow-hidden bg-gradient-to-b from-gray-50 to-white py-12 sm:py-16 lg:py-20 dark:from-gray-900 dark:to-gray-950">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="mb-10 text-center sm:mb-12 lg:mb-16">
            <p className="font-montserrat text-xs font-medium tracking-widest text-gray-500 uppercase sm:text-sm dark:text-gray-400">
              Trusted by Leading Clients
            </p>
            <div className="mx-auto mt-3 h-1 w-16 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 sm:mt-4 sm:w-20"></div>
          </div>

          {/* Carousel – bigger logos */}
          <div className="relative mx-auto max-w-7xl">
            <Swiper
              spaceBetween={24}
              slidesPerView={1}
              centeredSlides={isFewSlides} 
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
              breakpoints={{
                480: { slidesPerView: 2, spaceBetween: 32 },
                640: { slidesPerView: 3, spaceBetween: 40 },
                1024: { slidesPerView: 4, spaceBetween: 56 },
                1280: { slidesPerView: 5, spaceBetween: 72 },
              }}
              className="client-swiper !pb-12 sm:!pb-14 lg:!pb-16"
            >
              {clientList.map((logo, index) => (
                <SwiperSlide key={index}>
                  <div className="group flex h-28 items-center justify-center rounded-2xl bg-white p-4 shadow-sm transition-all duration-300 hover:shadow-xl sm:h-32 sm:p-6 lg:h-40 lg:p-8 dark:bg-gray-800/70 dark:hover:shadow-2xl">
                    <Image
                      src={logo}
                      alt={`Client ${index + 1}`}
                      fill
                      className="object-contain" // ← removed extra p-*
                      sizes="(max-width: 480px) 90vw, (max-width: 640px) 55vw, (max-width: 1024px) 40vw, 25vw"
                      priority={index < 4}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        {/* Custom Pagination Styling */}
        <style jsx global>{`
          .client-swiper .swiper-pagination {
            bottom: 0;
          }
          .client-swiper .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            background: #d1d5db;
            opacity: 1;
            transition: all 0.3s ease;
          }
          .client-swiper .swiper-pagination-bullet-active {
            background: linear-gradient(to right, #2563eb, #9333ea);
            width: 24px;
            border-radius: 4px;
          }
          .dark .client-swiper .swiper-pagination-bullet {
            background: #4b5563;
          }
          .dark .client-swiper .swiper-pagination-bullet-active {
            background: linear-gradient(to right, #60a5fa, #c084fc);
          }
        `}</style>
      </section>

      {/* Stats section */}
      <div className="mt-10 px-4 sm:mt-12 sm:px-6 lg:mt-16 lg:px-8">
        <div className="mx-auto flex max-w-5xl flex-col items-center justify-center gap-6 text-center sm:flex-row sm:gap-8 lg:gap-12">
          <div className="group w-full cursor-default sm:w-auto">
            <div className="text-3xl font-bold text-gray-900 transition-colors group-hover:text-blue-600 sm:text-4xl dark:text-white dark:group-hover:text-blue-400">
              100%
            </div>
            <div className="mt-1 text-sm text-gray-600 sm:text-base dark:text-gray-400">
              Client Satisfaction
            </div>
          </div>

          <div className="hidden h-10 w-px bg-gray-300 sm:block sm:h-12 dark:bg-gray-700" />

          <div className="group w-full cursor-default sm:w-auto">
            <div className="text-3xl font-bold text-gray-900 transition-colors group-hover:text-purple-600 sm:text-4xl dark:text-white dark:group-hover:text-purple-400">
              3+
            </div>
            <div className="mt-1 text-sm text-gray-600 sm:text-base dark:text-gray-400">
              Industry Leaders
            </div>
          </div>

          <div className="hidden h-10 w-px bg-gray-300 sm:block sm:h-12 dark:bg-gray-700" />

          <div className="group w-full cursor-default sm:w-auto">
            <div className="text-3xl font-bold text-gray-900 transition-colors group-hover:text-blue-600 sm:text-4xl dark:text-white dark:group-hover:text-blue-400">
              2+
            </div>
            <div className="mt-1 text-sm text-gray-600 sm:text-base dark:text-gray-400">
              Years Partnership
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientBanner;
